import type Client from '../client'
import BookingDates from './booking-dates'
import BookingTemplate from './booking-template'

export default class Booking {
  constructor(private client: Client) {}

  get dates(): BookingDates {
    return new BookingDates(this.client)
  }

  get template(): BookingTemplate {
    return new BookingTemplate(this.client)
  }
}
